<template>
    <div>
        <rkm-form
            ref="Form"
        >

            <rkm-row class="flex-nowrap" v-if="!model.laboratorioNome">

                <rkm-col class="flex-grow-1">
                    <rkm-form-select
                        :options="laboratorios"
                        label="Laboratório"
                        show-default-option
                        text-field="nomeFantasia"
                        v-model="model.laboratorioId"
                        :validations="validations.laboratorio"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col class="flex-grow-1">
                    <rkm-form-select
                        label="Local de atendimento"
                        :options="infraestruturas"
                        textField="nome"
                        v-model="model.infraestruturaId"
                        :validations="validations.infraestrutura"
                        valueField="id"
                        show-default-option
                    />
                </rkm-col>

                <rkm-col class="flex-grow-0">
                    <rkm-button
                        :label="false"
                        color="primary"
                        @click.stop="$refs.Form.validate(add)"

                    >
                        Incluir
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-row class="flex-nowrap" v-if="model.laboratorioNome">

            <rkm-col class="flex-grow-1">
                <rkm-form-input
                    label="Laboratório"
                    v-model="model.laboratorioNome"
                    disabled
                />
            </rkm-col>

            <rkm-col class="flex-grow-1">
                <rkm-form-input
                    label="Local de atendimento"
                    v-model="model.infraestruturaNome"
                    disabled
                />
            </rkm-col>

            <rkm-col class="flex-grow-0">
                <rkm-button
                    :label="false"
                    color="danger"
                    title="Excluir"
                    small
                    @click.stop="handleDestroy()"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>

// Mixins.
import { object } from '@/mixins'

export default {
    mixins: [ object ],
    computed: {
        fields() {

            const fields = [
                {
                    key: 'laboratorioNome',
                    label: 'Laboratório',
                    sortable: true
                },
                {
                    key: 'infraestruturaNome',
                    label: 'Local de atendimento',
                    sortable: true
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min',
                },
            ]

            return fields
        },
        validations() {

            return {
                laboratorio: { required: true },
                infraestrutura: { required: true },
            }
        },
        laboratorios() {

            return this.data.model.unidades
            .map(unidade => {
                return {
                    ...unidade,
                    id: unidade.unidadeId
                };
            })
            .filter(unidade => unidade.laboratorio === true)
            .sort((a, b) => a.nomeFantasia.localeCompare(b.nomeFantasia));
        },
        infraestruturas() {

            if (this.model.laboratorioId) {

                let infraestruturaPrincipal = this.data.form.unidades.find(u => u.id === this.model.laboratorioId).infraestruturas

                this.getPrincipal(infraestruturaPrincipal)

                return infraestruturaPrincipal
            }

            return []
        },
    },
    data: () => ({
        form: {
            unidades: {}
        },
        model: {
            laboratorioId: null,
            infraestruturaId: null,
            laboratorioNome: '',
            infraestruturaNome: '',
        },
        laboratorio: null,
    }),
    methods: {
        add(unidadeId = null, infraestruturaId = null) {

            if (unidadeId) {

                this.model.laboratorioId = unidadeId
                this.model.laboratorioNome = this.data.form.unidades
                    .find(s => s.id === unidadeId).nomeFantasia
            } else {

                this.model.laboratorioNome = this.data.form.unidades
                    .find(s => s.id === this.model.laboratorioId).nomeFantasia
            }

            if (infraestruturaId) {

                const unidade = this.data.form.unidades.find(s => s.id === unidadeId)
                const infraestrutura = unidade.infraestruturas.find(s => s.id === infraestruturaId)

                this.model.infraestruturaId = infraestruturaId
                this.model.infraestruturaNome = infraestrutura.nome
            } else {

                this.model.infraestruturaNome = this.infraestruturas
                    .find(s => s.id == this.model.infraestruturaId).nome
            }

            this.$emit('handleLaboratorioPadrao', this.model.infraestruturaId)
        },
        getPrincipal(infraestruturaPrincipal) {
            this.model.infraestruturaId = infraestruturaPrincipal.find(u => u.principal === true).id
        },
        resetForm() {

            this.model.laboratorioId = null
            this.model.laboratorioNome = ''
            this.model.infraestruturaNome = ''
            this.model.infraestruturaId = null

            this.$emit('handleLaboratorioPadrao', null)

            this.$nextTick(() => this.$refs.Form.resetValidator())
        },
        handleDestroy() {

            const destroy = async () => {

                this.resetForm()
            }

            this.showDeleteConfirmation(`Deseja realmente excluir o laboratório padrão?`, destroy)
        },
        handleLaboratorio(unidadeId, infraestruturaId) {

            this.resetForm()
            this.add(unidadeId, infraestruturaId)
        }
    },
    mounted() {

        if (!this.laboratorioPadraoInfraestruturaId) {
            return
        }

        const infraestruturaId = this.laboratorioPadraoInfraestruturaId

        const unidade = this.data.model.unidades.find(unidade =>
            unidade.infraestruturaId === infraestruturaId)

        this.model.laboratorioId = unidade.unidadeId
        this.model.laboratorioNome = unidade.nomeFantasia
        this.model.infraestruturaId = unidade.infraestruturaId
        this.model.infraestruturaNome = unidade.infraestruturaNome
    },
    props: {
        data: { type: Object, required: true },
        unidadeId: { type: Number, required: true },
        infraestruturaId: { type: Number, required: true },
        isLaboratorio: { type: Boolean, default: false },
        laboratorioPadraoInfraestruturaId: { type: Number, default: null },
    },
    watch: {
        'isLaboratorio'(value) {

            if (value) {

                if (!this.model.laboratorioNome) {

                    this.add(this.unidadeId, this.infraestruturaId)
                } else {

                    const isUnidade = this.model.infraestruturaId == this.infraestruturaId

                    if (!isUnidade) {

                        this.showConfirmation('Deseja definir este laboratório como padrão?',
                            async () => this.handleLaboratorio(this.unidadeId, this.infraestruturaId)
                        )
                    }
                }
            } else {

                const isUnidade = this.model.infraestruturaId == this.infraestruturaId

                if (isUnidade) {

                    this.showConfirmation(`Este laboratório está definido como padrão. Ao desmarcá-lo, ele
                        deixará de ser o laboratório padrão. Deseja continuar?`,
                        async () => this.resetForm(),
                        async () => this.$emit('handleLaboratorio'),
                    )
                }

            }
        },
    },
}
</script>